import { OrgPublicSiteSettingsTab } from '@/components/organization/OrgPublicSiteSettingsTab';
import { useOrganizationSettingsData } from '@/hooks/useOrganizationSettingsData';

interface OrganizationPublicSiteEmbedProps {
  onEmbeddedClose?: () => void;
}

export function OrganizationPublicSiteEmbed({ onEmbeddedClose: _onEmbeddedClose }: OrganizationPublicSiteEmbedProps) {
  const { organization, setOrganization, isInitialLoading } = useOrganizationSettingsData();

  if (isInitialLoading) {
    return (
      <div className="flex min-h-[200px] items-center justify-center" aria-busy="true">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900 dark:border-white" />
      </div>
    );
  }

  if (!organization) {
    return <p className="text-sm text-muted-foreground">Organization not found.</p>;
  }

  return <OrgPublicSiteSettingsTab organization={organization} onSaved={setOrganization} />;
}
